"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Search = _interopRequireDefault(require("./Search.render"));
/**
 * Business logic for the Desktop Nav Search component
 */
class SearchFunctionalityComponent extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.setInputRef = ref => {
      this.input = ref;
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.selected && !prevProps.selected && this.input) this.input.focus();
    if (!this.props.selected && prevProps.selected && this.input) this.input.blur();
  }
  render() {
    // @ts-ignore
    return /*#__PURE__*/React.createElement(_Search.default, Object.assign({}, this.props, {
      setInputRef: this.setInputRef
    }));
  }
}
exports.default = SearchFunctionalityComponent;